import {useEffect, useRef} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import {elementsInLoading, isLoadingByGroupToggle} from "../../../@signals";


export default function usePriceDiscountCountryWiseData() {
	const { urlApi } = usePricingDiscountRoleConfig()

	const isLoading = useSignal(false)
	const data = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value || isLoadingByGroupToggle.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${urlApi}/country-wise`, { ...commonFiltersValue.value }).then(res => {
				data.value = res.countryWise
				isLoading.value = false
			}).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			})
		}
	}, [isLoadingCommonFilters.value, groupedBy.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'countryWise']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'countryWise')
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value
	}
}